/**
 * @deprecated 兼容桥接层 — 将新 authStore 状态同步到旧 LoginStore
 *
 * 使用方式：在 AuthOrchestrator mount 后调用 startLoginStoreBridge()
 * 用途：确保仍消费 LoginStore.isLoggedIn 的旧代码得到正确值
 * 生命周期：随 SDK 完全移除后一并删除
 */
import { subscribe } from "valtio";
import { authStore } from "../store/auth-store";
import { appOspSecurity } from "@features/api/osp";

let unsubscribe: (() => void) | null = null;
let idTokenFetchInFlight = false;

function fetchAndSyncIdToken(): void {
  if (idTokenFetchInFlight) {
    return;
  }
  idTokenFetchInFlight = true;
  appOspSecurity
    .idToken()
    .then((result) => {
      if (result.id_token) {
        try {
          const { LoginStore } = require("@/src/store/modules/login");
          if (LoginStore.auth) {
            LoginStore.auth = { ...LoginStore.auth, idToken: result.id_token };
          }
        } catch {
          /* ignore */
        }
      }
    })
    .catch(() => {
      /* idToken fetch failed — quest APIs will degrade */
    })
    .finally(() => {
      idTokenFetchInFlight = false;
    });
}

export function startLoginStoreBridge(): () => void {
  if (unsubscribe) {
    return unsubscribe;
  }

  const syncState = () => {
    try {
      const { LoginStore } = require("@/src/store/modules/login");
      const status = authStore.status;

      if (status.state === "authenticated") {
        if (!LoginStore.isLoggedIn) {
          LoginStore.isLoggedIn = true;
          LoginStore.isFetching = false;
          LoginStore.isLoading = false;
        }
        if (
          status.tokens.accessToken &&
          LoginStore.auth?.accessToken !== status.tokens.accessToken
        ) {
          LoginStore.auth = {
            accessToken: status.tokens.accessToken,
            refreshToken: status.tokens.refreshToken,
            idToken: LoginStore.auth?.idToken,
          };
        }
        if (!LoginStore.auth?.idToken) {
          fetchAndSyncIdToken();
        }
      } else if (status.state === "idle") {
        if (LoginStore.isLoggedIn) {
          LoginStore.isLoggedIn = false;
        }
        LoginStore.isFetching = false;
        LoginStore.isLoading = false;
        // idle 即"无会话"：残留 auth / eoaAddress 会让旧代码读到已失效的 token
        LoginStore.auth = undefined;
        LoginStore.eoaAddress = undefined;
        LoginStore.loginType = undefined;
        LoginStore.subLoginType = undefined;
      } else if (
        status.state === "restoring" ||
        status.state === "authenticating"
      ) {
        LoginStore.isFetching = true;
      }
    } catch {
      /* LoginStore not yet loaded or circular dep — safe to ignore */
    }
  };

  syncState();

  unsubscribe = subscribe(authStore, syncState);

  return () => {
    unsubscribe?.();
    unsubscribe = null;
  };
}
